import Requester from "./Requester";

export function get(){
    const requester = new Requester();

    return requester.get(requester.getUrl('api/dashboard'))
}

export default {
    get,
}